export type Env = "운영" | "모의";

// 002 §7-2: 항상 운영을 기본으로 열되, 고객이 명시적으로 모의를 선택하면 그 값을 세션 동안만 유지.
export function renderEnvTabs(current: Env, onChange: (env: Env) => void): HTMLElement {
  const wrap = document.createElement("div");
  wrap.className = "env-tabs";

  (["운영", "모의"] as Env[]).forEach((env) => {
    const btn = document.createElement("button");
    btn.textContent = env;
    btn.className = env === current ? "active" : "";
    btn.addEventListener("click", () => onChange(env));
    wrap.appendChild(btn);
  });

  return wrap;
}
